import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import API, { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await API.post("/auth/login", { email: email.trim(), password });
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FDFBF7] flex items-center justify-center px-4">
      <div className="w-full max-w-sm bg-[#FAF6F0] rounded-3xl soft-shadow p-8" data-testid="admin-login-card">
        <div className="flex justify-center">
          <img src="/logo.jpeg" alt="Binfinite Mind" className="h-14 mix-blend-multiply" />
        </div>
        <p className="text-xs uppercase tracking-[0.3em] text-[#D98E32] text-center mt-2 font-semibold">Admin Panel</p>
        <form onSubmit={submit} className="mt-6 space-y-4" data-testid="admin-login-form">
          <div>
            <Label htmlFor="admin-email" className="text-xs text-[#5A6E63]">Email</Label>
            <Input id="admin-email" data-testid="admin-login-email" type="email" required value={email}
              onChange={(e) => setEmail(e.target.value)} placeholder="admin@binfinitemind.com"
              className="mt-1 bg-[#FDFBF7] border-[#2D5A47]/20" />
          </div>
          <div>
            <Label htmlFor="admin-password" className="text-xs text-[#5A6E63]">Password</Label>
            <Input id="admin-password" data-testid="admin-login-password" type="password" required value={password}
              onChange={(e) => setPassword(e.target.value)} placeholder="Your password"
              className="mt-1 bg-[#FDFBF7] border-[#2D5A47]/20" />
          </div>
          <Button type="submit" data-testid="admin-login-submit" disabled={loading}
            className="w-full rounded-full bg-[#2D5A47] hover:bg-[#224536] text-[#FDFBF7] h-11">
            {loading ? "Signing in..." : "Sign In"}
          </Button>
        </form>
        <Link to="/" className="block text-center text-xs text-[#5A6E63] mt-4 hover:text-[#2D5A47]" data-testid="admin-back-home">
          &larr; Back to home
        </Link>
      </div>
    </div>
  );
}
